import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useProductFilters } from '@nosto/preact'
import RadioFacet from './RadioFacet'
import { isPreferedSeller } from '../helpers'

const maxGridRows = 10;

const tagFilter = ({ value = "" }) => {
    // Exclude certain tags from showing up in the sidebar
    value = (value.toLowerCase()).trim();
    const ignoredPrefixes = ["cj.", "ygroup_", "nosto", "sms-", 'tag-'];
    const ignoredTags = ["yblocklist", "nostoblocklist", "sub", "ecom", "community_page"];
    if (ignoredTags.includes(value) || ignoredPrefixes.some((x) => value.startsWith(x))) {
        return false;
    }
    return true;
};

const flairFilter = ({ value = "" }) => {
    const ignoreList = ["uses tracking", "editor's picks", "on sale", "preferred seller"];
    value = (value.toLowerCase()).trim();
    if (ignoreList.includes(value)) {
        return false;
    }
    return true;
};

const cjBestFilter = ({ value = "" }) => {
    value = (value.toLowerCase()).trim();
    return value === "preferred seller"
}

const doesFilterExist = (facetData, filterValue) => facetData.some(facet => facet.value === filterValue)

const FilterButton = ({ selectedFilters, isFilterApplied, facetData, shouldCheckName }) => {
    if (!selectedFilters?.length) return null;

    const groupedFilters = {};
    selectedFilters.forEach(filter => {
        const { field } = filter;
        if (!groupedFilters[field]) {
            groupedFilters[field] = [];
        }
        groupedFilters[field].push(filter);
    });

    return (
        <>
            {isFilterApplied && <span> is </span>}
            {Object.values(groupedFilters).map(fieldGroup => (
                fieldGroup.map((filter, index) => (
                    doesFilterExist(facetData, filter.value) &&
                    shouldCheckName(filter) && (
                        <button key={filter.value} onClick={() => filter.remove()} className='plp-active-filter'>
                            <span className='text-neutral-600 leading-normal'>{filter.value}{(index !== fieldGroup.length - 1) && ','}</span>
                        </button>
                    )
                ))
            ))}
        </>
    );
};

export default ({ facet, isCategorySelected, updateSelectedFilters, selectedFilters, searchFilters }) => {

    const detailsRef = useRef(null);
    const dropdownRef = useRef(null);
    const { filters } = useProductFilters()
    const { toggleProductFilter } = useActions();
    const [show, setShow] = useState(false);
    const defaultClass = 'filter-dropdown-box filter-dropdown-menu border border-gray-300 rounded-lg p-4 absolute top-full start-0 bg-white mt-2 ';
    const [dropdownClasses, setDropdownClasses] = useState('hidden');

    const ChevronIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" class="chevron-icon duration-300" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 3.33333L10.6667 8L6 12.6667" stroke="#38BFC3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    }

    const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled

    const toggleFilter = (facet, value) => shouldShowNewSearch ? updateSelectedFilters({ ...value, field: facet.field }) : toggleProductFilter(facet.field, value.value, !value.selected)
    const keepIfNotStartingWithEquals = ({ value }) => {
        const v = (value || '').toString().trim();
        return v && !v.startsWith('=');
      };

    let facetData = facet.data || [];
    if (facet.name == "Cratejoy's best") {
        facetData = facetData.filter(cjBestFilter);
    } else if (facet.field === "tags1") {
        facetData = facetData
        .filter(tagFilter) // existing filters
        .filter(keepIfNotStartingWithEquals)   // or keepIfNotStartingWithEquals
        .slice(0, 20);    
    } else if (facet.field === "extra.cjx-flair_tags") {
        facetData = facetData.filter(flairFilter);
    }

    if (!facetData?.length) return '';

    const selectedFiltersCount = facetData.filter((v) => v.selected).length ?? 0;
    // Open up group with selected filters
    useEffect(() => {
        if (detailsRef.current && selectedFiltersCount > 0) {
            detailsRef.current.open = !shouldShowNewSearch;
        }
        if (show) {
            setDropdownClasses(defaultClass + 'block')
        } else {
            setDropdownClasses('hidden')
        }
    }, [selectedFiltersCount, show]);

    const shouldCheckName = (filter) => (facet.name === 'Ships to' || facet.name === 'Ships from') ? filter.name === facet.name : true

    const isFilterApplied = filters.length > 0 && filters.some(filter => doesFilterExist(facetData, filter.value) && shouldCheckName(filter))

    const menuToggle = () => {
        setShow(!show)
        document.addEventListener('click', (e) => {
            detailsRef.current && !detailsRef.current.contains(e.target) && setShow(false)
        })
    }


    function filterGrid(array, chunkSize) {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    }

    if (shouldShowNewSearch) {
        if (isPreferedSeller(facet)) return <RadioFacet facet={facet} facetOptions={facetData} searchFilters={searchFilters} ></RadioFacet>
        else if (!isCategorySelected) return (<div class='relative filter-dropdown cursor-pointer' onClick={() => menuToggle()}>
            <div ref={detailsRef} open={false}>
                <div class="px-4 py-2 text-sm rounded-lg bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 flex items-center gap-2 shadow-sm">
                    <span class={isFilterApplied ? 'bold-text leading-normal' : 'leading-normal'}>{facet.name}</span>
                    {
                        filters.length > 0 && <FilterButton selectedFilters={filters} isFilterApplied={isFilterApplied} facetData={facetData} shouldCheckName={shouldCheckName} />
                    }
                    {filters.length > 0 && filters.some(filter => doesFilterExist(facetData, filter.value) && shouldCheckName(filter)) ?
                        <button onClick={() => facetData.map(facetDetail => filters.forEach(filter => facetDetail.value === filter.value && shouldCheckName(filter) && filter.remove()))} class='plp-active-filter mr-1 ml-1'>
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 9L9 1M1 1L9 9" stroke="#707073" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        :
                        <div class='ml-1'>
                            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" class={`duration-300 ${show ? "rotate-180" : ""}`}>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.234315 0.83429C0.546734 0.521871 1.05327 0.521871 1.36569 0.83429L4 3.4686L6.63432 0.83429C6.94673 0.521871 7.45327 0.521871 7.76569 0.83429C8.0781 1.14671 8.0781 1.65324 7.76569 1.96566L4.56569 5.16566C4.25327 5.47808 3.74673 5.47808 3.43431 5.16566L0.234315 1.96566C-0.0781049 1.65324 -0.0781049 1.14671 0.234315 0.83429Z" fill="#111827" />
                            </svg>
                        </div>
                    }
                </div>
                <div class={dropdownClasses}>
                    <ul class='flex flex-row gap-2'>
                        {
                            filterGrid(facetData, maxGridRows).map((chunk, chunkIndex) => (
                                <div key={chunkIndex} class="flex flex-col gap-2">
                                    {chunk.map((value, index) => (
                                        <li key={value.value}>
                                            <label for={`filter-${facet.field}-${chunkIndex * maxGridRows + index}`} class='text-sm text-gray-700 flex items-center gap-3 cursor-pointer' onClick={(e) => {
                                                e.preventDefault()
                                                toggleProductFilter(facet.field, value.value, !value.selected);
                                            }}>
                                                <input
                                                    type="checkbox"
                                                    id={`filter-${facet.field}-${chunkIndex * maxGridRows + index}`}
                                                    name={facet.field}
                                                    checked={value.selected}
                                                    onChange={(e) => {
                                                        e.preventDefault()
                                                        toggleProductFilter(facet.field, value.value, !value.selected);
                                                    }}
                                                />
                                                <span>
                                                    {value.value}
                                                    {value.count < 2 ? null : ` (${value.count})`}
                                                </span>
                                            </label>
                                        </li>
                                    ))}
                                </div>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>)
    }

    return (
        <details
            ref={detailsRef}
            class="app--filters-facet"
            data-nosto-element="facet"
        >
            <summary class={window.cj.nosto.newSearchFeatureEnabled ? "mobile-sidebar-label" : "sec-sidebar--label"}>
                <span>
                    {facet.name}
                    {selectedFiltersCount > 0 && (
                        <span> ({selectedFiltersCount})</span>
                    )}
                </span>
                <ChevronIcon />

            </summary>
            <div class="sec-sidebar--container">
                <ul>
                    {facetData.map((value, loopIndex) => {
                        return (
                            <li class={window.cj.nosto.newSearchFeatureEnabled ? "mobile-sidebar-checkbox" : "sidebar-checkbox mobile-sidebar-checkbox"} data-nosto-element="facet-setting">
                                <input
                                    type="checkbox"
                                    class='mobile-checkbox'
                                    id={`filter-${facet.field}-${loopIndex}`}
                                    name={facet.field}
                                    checked={selectedFilters.some((data) => data?.value === value?.value && data.field === facet.field)}
                                    onChange={(e) => {
                                        e.preventDefault()
                                        toggleFilter(facet, value)
                                    }}
                                />
                                <label for={`filter-${facet.field}-${loopIndex}`}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        toggleFilter(facet, value)
                                    }}
                                >
                                    {value.value}
                                    {value.count < 2 ? null : ` (${value.count})`}
                                </label>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </details>
    )
}
